import React from "react";

import { useRecentItems } from "fond/hooks/useRecentItems";

import { BaseProjectList } from "./BaseProjectList";

/**
 * Recent content component
 */
const RecentContent: React.FC = () => {
  const recentItems = useRecentItems();
  return <BaseProjectList items={recentItems} />;
};

export default RecentContent;
